module.exports = __webpack_public_path__ + "img/Jump Casting44.b732341a.jpg";